import React, { RefObject, useEffect, useState } from 'react';
import { TooltipProps } from '@material-ui/core';
import Tooltip from './Tooltip';

interface EllipsisTooltipProps extends TooltipProps {
  overflowElementRef: RefObject<HTMLDivElement>;
}

function EllipsisTooltip({
  overflowElementRef,
  title,
  ...props
}: EllipsisTooltipProps) {
  const [showTT, setShowTT] = useState(false);
  useEffect(() => {
    const overflowElement = overflowElementRef?.current;
    if (
      overflowElement &&
      overflowElement.scrollWidth > overflowElement.clientWidth
    ) {
      setShowTT(true);
    }
  }, [overflowElementRef, title]);
  return <Tooltip {...props} title={showTT ? title : ''} />;
}

export default EllipsisTooltip;
